import 'react-simple-keyboard/build/css/index.css';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { YStack } from 'tamagui';

import { WifiPasswordPrompt } from './components/WifiPasswordPrompt';
import { CustomDialog, KeyboardInput } from '../../components/common';
import { useFirmwareContext } from '../../contexts/FirmwareContext';
import { ROUTE_PATHNAMES } from '../../routes/routeConstants';
import { StyledCard } from '../Settings_General/components/styles';

export const WifiConnectScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { networkName } = useParams();
  const { connectWifi, saveWifi } = useFirmwareContext();

  const [showKeyboard, setShowKeyboard] = useState(false);
  const [input, setInput] = useState('');
  const [showModal, setShowModal] = useState(false);
  const keyboardRef = useRef<any>(null);

  const goBack = () => navigate(ROUTE_PATHNAMES.wifi);

  useEffect(() => {
    setShowModal(false);
  }, []);

  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (showKeyboard && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showKeyboard]);

  const handleInputChange = (val: string) => {
    setInput(val);
    if (keyboardRef.current) {
      keyboardRef.current.setInput(val);
    }
  };

  const handleKeyboardChange = (val: string) => {
    setInput(val);
  };

  const handleConnect = async () => {
    if (!networkName) {
      setShowModal(true);
      return;
    }
    if (input.length < 1) {
      setShowModal(true);
      return;
    }
    try {
      await connectWifi(networkName, input);
      await saveWifi(networkName, input);
      setShowKeyboard(false);
      setInput('');
      navigate(ROUTE_PATHNAMES.wifi);
    } catch (err) {
      console.error('Connection failed:', err);
      setShowModal(true);
    }
  };

  const handleCancel = () => {
    setShowKeyboard(false);
  };

  const handleTryAgain = () => {
    setShowModal(false);
    setShowKeyboard(true);
  };

  return (
    <>
      <YStack padding="$5" overflow="visible">
        <StyledCard
          height={432}
          justifyContent="flex-start"
          padding={showKeyboard ? 0 : '$5'}
          overflow="visible">
          {showKeyboard ? (
            <KeyboardInput
              input={input}
              onInputChange={handleInputChange}
              onSubmit={handleConnect}
              onCancel={handleCancel}
              showModal={showModal}
              inputRef={inputRef}
              keyboardRef={keyboardRef}
              onKeyboardChange={handleKeyboardChange}
              buttonLabel={t('settings.wifi.connect')}
              placeholder={t('settings.wifi.wifiPassword')}
            />
          ) : (
            <WifiPasswordPrompt
              input={input}
              onInputChange={handleInputChange}
              onShowKeyboard={() => setShowKeyboard(true)}
              networkName={networkName}
              goBack={goBack}
            />
          )}
        </StyledCard>
      </YStack>
      <CustomDialog
        width="183px"
        open={showModal}
        onOpenChange={setShowModal}
        onButtonPress={handleTryAgain}
        buttonLabel={t('settings.wifi.tryAgain')}
        title={t('settings.wifi.incorrectPassword')}
        description={t('settings.wifi.incorrectPasswordDescription')}
      />
    </>
  );
};
